import React from "react";
import { Helmet } from "react-helmet-async";
import { SEO_DEFAULTS } from "./seoConfig";

function buildAbsoluteUrl(origin, path) {
  if (!origin) return "";
  if (!path) return origin;
  return `${origin}${path.startsWith("/") ? "" : "/"}${path}`;
}

export default function Seo({
  title,
  description,
  keywords,
  path = "/",
  noIndex = false,
}) {
  const siteUrl =
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== "undefined" ? window.location.origin : "");

  const resolvedTitle = title
    ? title.includes(SEO_DEFAULTS.siteName)
      ? title
      : `${title} | ${SEO_DEFAULTS.siteName}`
    : SEO_DEFAULTS.defaultTitle;

  const resolvedDescription = description || SEO_DEFAULTS.defaultDescription;
  const resolvedKeywords = keywords || SEO_DEFAULTS.defaultKeywords;
  const canonicalUrl = buildAbsoluteUrl(siteUrl, path);
  const ogImageUrl = buildAbsoluteUrl(siteUrl, SEO_DEFAULTS.ogImagePath);

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "AccountingService",
    name: SEO_DEFAULTS.siteName,
    url: siteUrl || undefined,
    telephone: SEO_DEFAULTS.phoneE164,
    email: SEO_DEFAULTS.email,
    address: {
      "@type": "PostalAddress",
      ...SEO_DEFAULTS.address,
    },
    logo: ogImageUrl || undefined,
  };

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <meta name="keywords" content={resolvedKeywords} />
      <meta name="author" content={SEO_DEFAULTS.siteName} />
      <meta
        name="robots"
        content={noIndex ? "noindex,nofollow" : "index,follow"}
      />

      {canonicalUrl ? <link rel="canonical" href={canonicalUrl} /> : null}

      <meta property="og:site_name" content={SEO_DEFAULTS.siteName} />
      <meta property="og:locale" content={SEO_DEFAULTS.locale} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      {canonicalUrl ? <meta property="og:url" content={canonicalUrl} /> : null}
      {ogImageUrl ? <meta property="og:image" content={ogImageUrl} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      {ogImageUrl ? <meta name="twitter:image" content={ogImageUrl} /> : null}

      <script type="application/ld+json">
        {JSON.stringify(organizationJsonLd)}
      </script>
    </Helmet>
  );
}

